<template>
    <div class="col-sm-9">
        <div class="new_soproni_small_area">
            <div class="row">
                <div class="col-sm-12">
                    <div class="section_title_box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="section_title">
                                    <div class="section_title_cont text-left">
                                        <h3>KEDVENCEIM</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-sm-12">
                    <div class="ked_menu_box">
                        <div class="ked_menu_box_cont">
                            <div class="row">
                                <div class="col-sm-3">
                                    <!-- <div class="dust_box">
                                        <div class="dust_cont_box">
                                            <div class="bin_image">
                                                <img src="images/been.png" alt="">
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="col-sm-9">
                                    <div class="ked_menu">
                                        <div class="ked_menu_cont">
                                            <ul>
                                                <li>Terméknév</li>
                                                <li>Bruttó egységár</li>
                                                <li>Mennyiség</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row" v-for="p in watched.list">
                <div class="kedvenciam_all_area">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="tick_box">
                                        <div class="dust_chq_box">
                                            <div class="bin_image" @click="removeElement(p)">
                                                <img src="images/been.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kedvenciam_all_small_can">
                                        <img :src="p.imageUrl" alt="">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="kedvenciam_all_small_title">
                                        <h6>{{p.name}}</h6>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    <div class="kedvenciam_all_quantity_small_title">
                                        <p>{{p.price && p.price.toLocaleString('hu')}} Ft</p>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="small_quantity_count">
                                        <form id="" action="">
                                            <div class="form-group">
                                                <input class="form-control" type="number" placeholder="1" name="date" min="1" step="1" v-model="p.q">
                                            </div>
                                        </form>
                                    </div>
                                    <div class="new_db_txt">
                                        <div class="new_db_txt_box">
                                            <p>db</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thm_btn_boxes">
                                        <div class="thm_btn text-center">
                                            <a @click="addToBasket(p)">Kosárba<i class="fa fa-shopping-basket" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <promoted></promoted>

    </div>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'
import Promoted from '@pages/list/Promoted.vue'


export default{
    mixins:[Endpoints],
    components:{
        Promoted
    },
    computed:{
        watched:function () {
            return this.$store.getters.getWatched;
        }
    },
    methods:{
        addToBasket: function(p){
            var o ={
                product:p,
                quantity:p.q
            }

            var self = this;
            this.connBasketAdd(o,function (r) {
                self.$store.commit('setBasket',r.data);
                toastr.success('A termék sikeresen hozzá lett adva a kosaradhoz');
            },function (r) {
                if (r.data.errorCode == 1207){
                    toastr.warning('Túllépted a maximális súlyhatárt.');
                }
                if (r.data.errorCode == 1203){
                    toastr.warning('A termékből nem áll rendelkezésre a kívánt mennyiség.');
                }
            })
        },
        removeElement:function (p) {
            var self = this;
            this.connWatchedRemove(p.id,function (r) {
                self.$store.commit('setWatched',r.data);
            })
        },
    }
}

</script>

<style>
.bin_image img{
    cursor: pointer;
}
.kedvenciam_all_small_can {
    text-align: right;
}
.kedvenciam_all_small_can img{
    width: 50%;
}
</style>



// WEBPACK FOOTER //
// Favorites.vue?00a70679